import { render, staticRenderFns } from "./Tickethistory.vue?vue&type=template&id=989622fc&scoped=true"
import script from "./Tickethistory.vue?vue&type=script&lang=js"
export * from "./Tickethistory.vue?vue&type=script&lang=js"
import style0 from "./Tickethistory.vue?vue&type=style&index=0&id=989622fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989622fc",
  null
  
)

export default component.exports